export type RecordSequenceSlot = null | string;

export interface RecordSequencePlace {
	nextIndex: null | number;
	position: null | number;
	previousIndex: null | number;
}

export interface RecordSequencePosition {
	nextId: null | string;
	position: number;
	previousId: null | string;
	total: number;
}

const placeAtIndex = (length: number, index: number): RecordSequencePlace => ({
	nextIndex: index < length - 1 ? index + 1 : null,
	position: index + 1,
	previousIndex: index > 0 ? index - 1 : null
});

const placeAfterRemoval = (length: number, anchorIndex: number): RecordSequencePlace => {
	const previousIndex = Math.min(anchorIndex, length) - 1;
	return {
		nextIndex: anchorIndex < length ? anchorIndex : null,
		position: null,
		previousIndex: previousIndex >= 0 ? previousIndex : null
	};
};

const placeAt = (
	slots: readonly RecordSequenceSlot[],
	currentId: string,
	anchorIndex: null | number
): RecordSequencePlace | null => {
	const index = slots.indexOf(currentId);
	if (index >= 0) return placeAtIndex(slots.length, index);
	if (anchorIndex === null) return null;
	if (anchorIndex < slots.length && slots[anchorIndex] === null) return placeAtIndex(slots.length, anchorIndex);
	return placeAfterRemoval(slots.length, anchorIndex);
};

const sequencePosition = (sequence: readonly string[], id: string): RecordSequencePosition => {
	const place = placeAt(sequence, id, null);
	return {
		nextId: place?.nextIndex == null ? null : sequence[place.nextIndex],
		position: place?.position ?? 0,
		previousId: place?.previousIndex == null ? null : sequence[place.previousIndex],
		total: sequence.length
	};
};

const recordSequence = { placeAt, sequencePosition };

export default recordSequence;
